import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import CancellationPolicies from './CancellationPolicies';

import messages from '../../../locale/jsonMessages';
import { restrictUrls } from '../../../helpers/adminPrivileges';

export default async function action({ store, intl }) {

    const title = intl ? intl?.formatMessage(messages.cancellationPolicyManagement) : "Cancellation Policy Management";
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/cancellation-policies', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout><CancellationPolicies title={title} /></AdminLayout>,
    };
}
